import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import './MainLayout.css';

const MainLayout = ({ children, title }) => {
  return (
    <div className="admin-layout">
      <Sidebar />
      <div className="main-content-wrapper">
        <Header title={title} />
        <main className="page-content fade-in">
          {children}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
